import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { EntityService } from 'shared/core/services/entity.service';

export function rateControllerPath(selectedHotelIds: string[] | undefined): string | null {
    const count = new Set(selectedHotelIds ?? []).size;
    if (!count) return null;
    return count === 1
        ? 'dashboard/rate-controller-single'
        : 'dashboard/rate-controller-corp';
}

export function rateControllerUrlTree(router: Router, url: string, path: string): UrlTree {
    const current = router.parseUrl(url);
    return router.createUrlTree(['/products/rate', ...path.split('/')], {
        queryParams: current.queryParams,
        fragment: current.fragment,
    });
}

// Resolve the selection before constructing a dashboard or starting its API calls.
export const rateControllerSelectionGuard: CanActivateFn = (route, state) => {
    const entityService = inject(EntityService);
    const router = inject(Router);
    const resolve = (): boolean | UrlTree => {
        const path = rateControllerPath(entityService.selectedEntityIds);
        return path && path !== route.routeConfig.path
            ? rateControllerUrlTree(router, state.url, path)
            : true;
    };

    if (entityService.selectedEntityIds?.length) return resolve();
    return entityService.on_ready.pipe(filter(Boolean), take(1), map(resolve));
};
